import * as Yup from "yup";

export const LogInSchema = Yup.object({
    username: Yup.string().required(" Enter User Name"),
    password: Yup.string().required(" Enter Your Password"),
    // bussiness_id: Yup.string().required("Select Bussiness Area"),
});